module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Role === '1') ? _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.isAlipay) ? _c('h3', [_vm._v("支付宝小程序帮助中心")]) : _vm._e(), _vm._v(" "), (!_vm.isAlipay) ? _c('h3', [_vm._v("帮助中心")]) : _vm._e()])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[0]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommon
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.comonQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.commonDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.commonEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[1]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPay
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.payQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.payDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.payEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v(_vm._s(_vm.titles[2]))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDinner
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _vm._l((_vm.dinnerQ), function(o, i) {
    return _c('div', {
      key: i,
      staticClass: "text item"
    }, [_c('p', [_vm._v("\n                    标题：" + _vm._s(o.Q) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                    内容：" + _vm._s(o.A) + "\n                ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.orderDelete(i)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info"
      },
      on: {
        "click": function($event) {
          return _vm.orderEdit(i)
        }
      }
    }, [_vm._v("编辑")])], 1)
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '新增' + _vm.titles[0],
      "visible": _vm.dialogCommon,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCommon = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCommonOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '编辑' + _vm.titles[1],
      "visible": _vm.dialogCommonEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCommonEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommonEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCommonOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": '编辑' + _vm.titles[2],
      "visible": _vm.dialogPayEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPayEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogPayEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editPayOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑订单问题",
      "visible": _vm.dialogDinnerEdit,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDinnerEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogDinnerEdit = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editDinnerOne
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增订单问题",
      "visible": _vm.dialogDinner,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDinner = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDinnerOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增支付问题",
      "visible": _vm.dialogPay,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPay = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "label-width": "150px",
      "prop": "Q"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.Q),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "Q", $$v)
      },
      expression: "newForm.Q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "label-width": "150px",
      "prop": "A"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.A),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "A", $$v)
      },
      expression: "newForm.A"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCommon = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addPayOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadHelp
    }
  }, [_vm._v("提交")])], 1)]) : _c('h3', [_vm._v("\n    暂无权限\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63552986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/other/Help.vue
// module id = 736
// module chunks = 1